import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RoutingService } from '@zaoblako/web/core/services/routing.service';
import { AuthService } from '@zaoblako/web/core/services/security/auth.service';
import { ButtonModule } from 'primeng/button';

@Component({
  standalone: true,
  selector: 'crm-page-not-found',
  templateUrl: './page-not-found.component.html',
  imports: [CommonModule, ButtonModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageNotFoundComponent {
  public constructor(private readonly routingService: RoutingService, private readonly authService: AuthService) {}

  public redirectBack() {
    this.routingService.goToPreviousUrl(this.authService.currentProfile?.sessionMode);
  }

  public redirectToHomepage() {
    this.routingService.goToPreviousUrl(this.authService.currentProfile?.sessionMode);
  }
}
